const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M16 1H6C3.23858 1 1 3.23858 1 6V16C1 18.7614 3.23858 21 6 21H16C18.7614 21 21 18.7614 21 16V6C21 3.23858 18.7614 1 16 1Z"
      stroke="#575378"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 10.3701C15.1234 11.2023 14.9812 12.0523 14.5937 12.7991C14.2062 13.5459 13.5931 14.1515 12.8416 14.5297C12.0901 14.908 11.2384 15.0397 10.4077 14.906C9.57708 14.7723 8.80971 14.3801 8.21479 13.7852C7.61987 13.1903 7.22768 12.4229 7.09402 11.5923C6.96035 10.7616 7.09202 9.90995 7.47028 9.15843C7.84854 8.40691 8.45414 7.7938 9.20094 7.4063C9.94773 7.0188 10.7977 6.87665 11.63 7.00006C12.4789 7.12594 13.2648 7.52152 13.8716 8.12836C14.4785 8.73521 14.8741 9.52113 15 10.3701Z"
      stroke="#575378"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 5.5H16.51"
      stroke="#575378"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default InstagramIcon
